import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 15H11.25V19.6275L9.3075 17.6925L8.25 18.75L12 22.5L15.75 18.75L14.6925 17.6925L12.75 19.6275V15H21V13.5H3V15Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.25 5.25L9.3075 6.3075L11.25 4.3725V9H3V10.5H21V9H12.75V4.3725L14.6925 6.3075L15.75 5.25L12 1.5L8.25 5.25Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgDragVertical;
